import _ from 'lodash';
import moment from 'moment';

import { setError } from '../App/ErrorsActions';
import { fetchAnalysisData } from '../App/AppActions';
import customFieldsUtils from '../../util/customFieldsUtils';
import { getDefaultMarkBlockedValue } from '../../util/filterUtils';
import CalculationsWorker from '../../services/worker';

export const LOADING = 'ANALYSIS_LOADING';
export const DATA = 'ANALYSIS_DATA';
export const DATES = 'ANALYSIS_DATES';
let processWorker = null;
let lastWorkerParams = null;
const METRICS = {};

export function isLoading(bool) {
  return {
    type: LOADING,
    analysisRunning: bool
  };
}

function success(chart, data) {
  return {
    type: DATA,
    chart,
    data
  };
}

function metric(name) {
  if (METRICS[name]) {
    const value = Math.floor((+new Date() - METRICS[name]) / 1000);
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;
    METRICS[name] = `${minutes} min. ${seconds} sec`;
  } else {
    METRICS[name] = +new Date();
  }
}

export function getData() {
  return async (dispatch, getState) => {
    metric('ANALYSIS');

    const { analysisDates } = getState().filters;
    const { selected } = getState().dashboards;
    const { user } = getState().auth;

    await dispatch(fetchAnalysisData(analysisDates, selected._id, user.config.disableCfActivities));   
    
    metric('ANALYSIS');
  };
}

export function runAnalysis() {
  
  return async (dispatch, getState) => {
    dispatch(isLoading(true));
    const allFilters = getState().filters;
    const { allCustomFields, excludeWeekends, workStart, workEnd, holidays, analysisDates, enabledColors } = allFilters;
    const { selected } = getState().dashboards;
    const { user } = getState().auth;
    const { analysisData } = getState().app;

    const filters = allFilters.overview;

    filters.selectedLists = _.filter(filters.selectedLists, l => {
      return _.indexOf(selected.todo, l._id) === -1;
    });

    const currentParams = {
      selectedId: selected._id,
      analysisDataHash: getState().app.analysisDataHash,
      enabledColors: [...enabledColors],
      config: _.pick(user.config, ['enableDoneFilters', 'enableUnmappedListsActivities'])
    };

    if (!processWorker || !_.isEqual(currentParams, lastWorkerParams)) {
      if (processWorker) {
        processWorker.terminate(); 
      }
      metric('INIT PROCESS WORKER');
      const processService = new CalculationsWorker();
      processWorker = processService.wrap();
      processWorker = await new processWorker(selected, analysisData, enabledColors, {
        enableDoneFilters: user.config.enableDoneFilters,
        enableUnmappedListsActivities: user.config.enableUnmappedListsActivities
      });
      metric('INIT PROCESS WORKER');
      lastWorkerParams = currentParams;
    }  

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);
    const getCtAnalysis = () => {
      metric('PI-CT');
      return new Promise(async resolve => {
        try {
          let ctAnalysisData = await processWorker.CycleTimeAnalysis({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: analysisDates.startDate.toISOString(),
            to: analysisDates.endDate.toISOString(),
            timeUnit: 'day',
            markBlocked: getDefaultMarkBlockedValue(analysisData.app, selected),
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues
          });
          dispatch(success('ctAnalysis', ctAnalysisData));
          metric('PI-CT');
          return resolve(ctAnalysisData);
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getWIPAgeAnalysis = () => {
      metric('PI-WIPAGE');
      return new Promise(async resolve => {
        try {
          let wipAgeAnalysisData = await processWorker.WipAgeAnalysis({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: analysisDates.startDate.toISOString(),
            to: analysisDates.endDate.toISOString(),
            timeUnit: 'day',
            markBlocked: allFilters.ctsp.markBlocked && getDefaultMarkBlockedValue(analysisData.app, selected),
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues
          });
          dispatch(success('wipAgeAnalysis', wipAgeAnalysisData));
          metric('PI-WIPAGE');
          return resolve(wipAgeAnalysisData);
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getWIPAnalysis = () => {
      metric('PI-WIP');
      return new Promise(async resolve => {
        try {
          let wipAnalysisData = await processWorker.WipAnalysis({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: analysisDates.startDate.toISOString(),
            to: analysisDates.endDate.toISOString(),
            timeUnit: 'day',
            markBlocked: allFilters.ctsp.markBlocked && getDefaultMarkBlockedValue(analysisData.app, selected),
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues
          });
          dispatch(success('wipAnalysis', wipAnalysisData));
          metric('PI-WIP');
          return resolve(wipAnalysisData);
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getFeAnalysis = () => {
      metric('PI-FE');
      return new Promise(async resolve => {
        try {
          let feAnalysisData = await processWorker.FlowEfficiencyAnalysis({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            selectedQueueLists: filters.selectedQueueLists,
            from: analysisDates.startDate.toISOString(),
            to: analysisDates.endDate.toISOString(),
            timeUnit: 'day',
            markBlocked: getDefaultMarkBlockedValue(analysisData.app, selected),
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues
          });
          dispatch(success('feAnalysis', feAnalysisData));
          metric('PI-FE');
          return resolve(feAnalysisData);
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getThAnalysis = () => {
      metric('PI-TH');
      return new Promise(async resolve => {
        try {
          let thAnalysisData = await processWorker.ThroughputAnalysis({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: analysisDates.startDate.toISOString(),
            to: analysisDates.endDate.toISOString(),
            timeUnit: 'day',
            markBlocked: getDefaultMarkBlockedValue(analysisData.app, selected),
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues
          });
          dispatch(success('thAnalysis', thAnalysisData));
          metric('PI-TH');
          return resolve(thAnalysisData);
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getCtbAnalysis = () => {
      metric('PI-CTB');
      return new Promise(async resolve => {
        try {
          let ctbAnalysisData = await processWorker.CycleTimeBreakDownAnalysis({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: analysisDates.startDate.toISOString(),
            to: analysisDates.endDate.toISOString(),
            timeUnit: 'day',
            markBlocked: getDefaultMarkBlockedValue(analysisData.app, selected),
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues
          });
          dispatch(success('ctbAnalysis', ctbAnalysisData));
          metric('PI-CTB');
          return resolve(ctbAnalysisData);
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };
    const promises = [
      getCtAnalysis(),
      getWIPAgeAnalysis(),
      getWIPAnalysis(),
      getFeAnalysis(),
      getThAnalysis(),
      getCtbAnalysis()
    ];
    await Promise.all(promises);
  };
}
